import { Snackbar, Alert } from '@mui/material';
import { useContext } from 'react';
import { ProjectsContext } from './ProjectsContext';

const AdminProjectsSnackbar = () => {
    const { snackbar, handleCloseSnackbar } = useContext(ProjectsContext);
    return (
        <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
    );
};

export default AdminProjectsSnackbar;
